import { NAVIGATION } from '../../config';
import { loginService, membersService } from '../../transport';
import { navigation } from '../../utils';

import { getMemberInvitations } from './member';
import { getMemberOrganizations } from './organizations';

export const NAMES = {
  LOGOUT_SUCCESS: 'LOGOUT_SUCCESS',
  CHECK_SESSION_SUCCESS: 'CHECK_SESSION_SUCCESS',
  CHECK_SESSION_ERROR: 'CHECK_SESSION_ERROR',
  CLEAR_SESSION: 'CLEAR_SESSION',
};

export const logoutSuccess = () => {
  navigation.goToPath(NAVIGATION.LOGIN_STATE);

  return {
    type: NAMES.LOGOUT_SUCCESS,
  };
};

export const clearSession = () => ({
  type: NAMES.CLEAR_SESSION,
  payload: undefined,
});

const checkSessionSuccess = (payload) => ({
  type: NAMES.CHECK_SESSION_SUCCESS,
  payload,
});

export const logout = () => (dispatch) => {
  return loginService.logout().then(() => dispatch(logoutSuccess()));
};

// NOTE: for now we are using members api to get information about user's profile
// but it's much clearer to keep this logic in login section not in member's
export const checkSession = () => (dispatch) => {
  return membersService.getUserInfo().then((response) => {
    const memberId = response.data.payload.id;

    return Promise.all([
      getMemberOrganizations({ memberId })(dispatch),
      getMemberInvitations({ memberId })(dispatch),
    ]).then(() => {
      dispatch(checkSessionSuccess(response.data.payload));
      return response;
    });
  });
};
